import React from "react";
/**
 * PageShell — the outer wrapper every template renders inside.
 * Enforces vertical section rhythm (§4 spacing) and prevents pages
 * from inventing their own scaffolding.
 */
export default function PageShell({ children, testId }) {
  return <div className="tpl-shell" data-testid={testId || "tpl-shell"} data-design-workspace="1">{children}</div>;
}
